import { ApiError } from '@/lib/api-client'

/**
 * Global TanStack Query retry kararı. 4xx (401/403/404 vb.) kalıcı hatalardır —
 * retry anlamsız ve gereksiz Sentry noise üretir. Yalnızca geçici hatalarda
 * (5xx, network) bir kez dene.
 */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  return isTransientQueryError(error) && failureCount < 1
}

/**
 * Query hatasının kendiliğinden düzelmesi beklenebilir mi?
 * 4xx yanıtları istemci/kimlik/yetki kaynaklı kalıcı hatalardır; 5xx ve ağ
 * hataları geçici kabul edilir.
 *
 * İSTİSNA — HTTP 429 (#492 review): rate limit 4xx aralığındadır ama KALICI DEĞİLDİR;
 * pencere dolunca kendiliğinden düzelir. Kalıcı sayılırsa gerçek bir Pro/admin
 * kullanıcının entitlement güveni anında iptal edilir, "yeniden deneniyor" durumu
 * hiç kurulmaz ve periyodik yenileme başlamaz — yani #492'nin ta kendisi tekrarlar.
 * data-service uygulama seviyesinde 429 döndürüyor (`app.py` errorhandler), Supabase
 * gateway'i de rate-limit'te 429 verir; senaryo varsayımsal değil.
 */
export const TRANSIENT_HTTP_STATUSES = new Set([429])

export function isTransientQueryError(error: unknown): boolean {
  if (!(error instanceof ApiError)) return true
  if (TRANSIENT_HTTP_STATUSES.has(error.status)) return true
  return !(error.status >= 400 && error.status < 500)
}
